module.exports = require("./mni.d.ts");